<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <h1 class="login-title">Welcome Back</h1>
        <p class="login-subtitle">Sign in to continue to your account</p>
      </div>

      <form class="login-form" @submit.prevent="onSubmit">
        <div class="form-group">
          <label for="inputEmail" class="form-label">Email Address</label>
          <div class="input-wrapper">
            <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
            <input
              type="email"
              id="inputEmail"
              class="form-input"
              placeholder="Enter your email"
              required
              autofocus
              v-model="email"
            >
          </div>
        </div>

        <div class="form-group">
          <label for="inputPassword" class="form-label">Password</label>
          <div class="input-wrapper password-wrapper">
            <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
            <input
              :type="showPassword ? 'text' : 'password'"
              id="inputPassword"
              class="form-input password-input"
              placeholder="Enter your password"
              required
              v-model="password"
            >
            <button
              type="button"
              class="password-toggle"
              :aria-label="showPassword ? 'Hide password' : 'Show password'"
              @click="togglePasswordVisibility"
            >
              <svg v-if="!showPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 9.9A3 3 0 0 1 14.1 14.1"></path>
                <path d="M1 1l22 22"></path>
              </svg>
            </button>
          </div>
        </div>

        <transition name="fade">
          <div v-if="loginError" class="error-message">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            <span>Invalid email or password. Please try again.</span>
          </div>
        </transition>

        <button class="btn-signin" type="submit">
          Sign In
        </button>

        <div class="form-links">
          <router-link :to="{ name: 'Password Reset Request' }" class="link-forgot">
            Forgot password?
          </router-link>
        </div>

        <div class="divider">
          <span>or</span>
        </div>

        <p class="signup-prompt">
          Don't have an account?
          <router-link to="/register" class="link-signup">Sign Up</router-link>
        </p>
      </form>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        email: '',
        password: '',
        showPassword: false,

        loginError: false,
      }
    },
    methods: {
      togglePasswordVisibility () {
        this.showPassword = !this.showPassword
      },
      loginform () {
        console.log(this.email);
        if (this.email) {
          this.$store.dispatch('logMeIn', this.email);
        }
      },
      onSubmit () {
        const formData = {
          email: this.email,
          password: this.password,
        }
        console.log(formData)
        // axios.post('https://vuejs-http-cf9e8.firebaseio.com/users.json', formData)
        // axios.post('/users.json', formData)
        // axios.post('/accounts:signUp?key=AIzaSyDWYJvc78apG41_YVaqlzNpA--57axNroQ', formData)
        // axios.post('/accounts:signUp?key=AIzaSyDWYJvc78apG41_YVaqlzNpA--57axNroQ', {
        // axios.post('http://127.0.0.1:8000/api-token-auth/', {
        //   username: formData.email,
        //   password: formData.password,
        // })
        //   .then(res => console.log(res))
        //   .catch(error => console.log(error))
        this.$store.dispatch('login', {email: this.email, password: this.password})
          .then(() => {
            console.log('Successful login!')
            // console.log(axios.defaults.baseURL)
          })
          .catch(error => {
            console.log('problemoo logging in')
            this.loginError = true
          })
      },
      demoLogin() {
        this.$store.dispatch('login', {email: 'myrundash@gmail.com', password: 'myrundash'})
          .then(() => {
            console.log('Successful demo login!')
            // console.log(axios.defaults.baseURL)
          })
          .catch(error => {
            console.log('problemoo logging into demo')
            this.loginError = true
          })
      },
    },
  }
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.login-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  padding: 48px;
  width: 100%;
  max-width: 440px;
  animation: slideUp 0.5s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.login-title {
  font-size: 32px;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 8px 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.login-subtitle {
  font-size: 16px;
  color: #718096;
  margin: 0;
  font-weight: 400;
}

.login-form {
  width: 100%;
}

.form-group {
  margin-bottom: 24px;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 8px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 16px;
  color: #a0aec0;
  pointer-events: none;
  transition: color 0.3s ease;
}

.form-input {
  width: 100%;
  padding: 14px 16px 14px 48px;
  font-size: 16px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  outline: none;
  transition: all 0.3s ease;
  background-color: #f7fafc;
  color: #2d3748;
}

.password-input {
  padding-right: 48px;
}

.password-toggle {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #718096;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: color 0.3s ease;
}

.password-toggle:hover {
  color: #4a5568;
}

.form-input::placeholder {
  color: #a0aec0;
}

.form-input:focus {
  border-color: #667eea;
  background-color: white;
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
}

.form-input:focus + .input-icon,
.input-wrapper:focus-within .input-icon {
  color: #667eea;
}

.error-message {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  background-color: #fff5f5;
  border: 1px solid #fc8181;
  border-radius: 12px;
  color: #c53030;
  font-size: 14px;
  margin-bottom: 24px;
  animation: shake 0.4s ease;
}

.error-message svg {
  flex-shrink: 0;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-10px); }
  75% { transform: translateX(10px); }
}

.fade-enter-active, .fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.btn-signin {
  width: 100%;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  color: white;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  margin-bottom: 16px;
}

.btn-signin:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5);
}

.btn-signin:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.form-links {
  text-align: center;
  margin-bottom: 24px;
}

.link-forgot {
  font-size: 14px;
  color: #667eea;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.link-forgot:hover {
  color: #764ba2;
  text-decoration: underline;
}

.divider {
  position: relative;
  text-align: center;
  margin: 32px 0;
}

.divider::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 1px;
  background-color: #e2e8f0;
}

.divider span {
  position: relative;
  display: inline-block;
  padding: 0 16px;
  background-color: white;
  color: #a0aec0;
  font-size: 14px;
  font-weight: 500;
}

.signup-prompt {
  text-align: center;
  font-size: 15px;
  color: #4a5568;
  margin: 0;
}

.link-signup {
  color: #667eea;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.3s ease;
}

.link-signup:hover {
  color: #764ba2;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .login-container {
    padding: 16px;
    background: white;
  }

  .login-card {
    padding: 32px 24px;
    box-shadow: none;
    border-radius: 0;
  }

  .login-title {
    font-size: 28px;
  }

  .login-subtitle {
    font-size: 14px;
  }

  .form-input {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .login-card {
    padding: 24px 20px;
  }

  .login-title {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue